<ng-container *ngIf="visible">
    <ng-container *ngTemplateOutlet="mobile ? mobileLayout: desktopLayout"></ng-container>
</ng-container>

<ng-template #desktopLayout>

    <div class="filter--container filter-scroll">
        <div [ngClass]="{'filter-scroll--fixed': fixedPosition}"
             [ngStyle]="styles">
            <div>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="font-weight-bold uppercase">Filter By:</h5>
                    <a *ngIf="hasSelectedFilters" class="link link-underline small" (click)="clearAll()" href="javascript:void(0)">Clear All</a>
                </div>
                <ul class="products-list__filters mb-0">
                    <ng-container *ngFor="let filter of sortedFiltersGroup">
                        <li *ngIf="isVisible(filter)" class="products-list__filters__section">
                            <filter-group [filter]="filter"
                                          [filterItemHeight]="filterItemMaxHeight"
                                          (toggledFilter)="toggleDropdown($event)"
                                          (changedFilter)="onFilterChanged($event)"
                                          (updatedFilter)="updateFilters($event)"></filter-group>
                        </li>

                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mobileLayout>
    <div class="position-relative">
        <a href="#" class="link link-underline uppercase" (click)="toggleFiltersModal()">Filter By&nbsp;<i class="fas fa-filter"></i></a>
        <div class="filter-content__mobile p-2" [ngStyle]="mobileDialogStyles" [ngClass]="{'opened' : mobileOpened}">
            <div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-baseline">
                        <h5 class="font-weight-bold uppercase">Filter By</h5>
                        <a *ngIf="hasSelectedFilters" class="ml-3 link link-underline small" (click)="clearAll()" href="javascript:void(0)">Clear All</a>
                    </div>
                    <button type="button" (click)="toggleFiltersModal()" class="btn btn-icon close" aria-label="Close"><span class="far fa-times font-weight-bold" aria-hidden="true"></span></button>
                </div>
                <ul class="products-list__filters mb-0">
                    <ng-container *ngFor="let filter of _filters">
                        <li *ngIf="isVisible(filter)" class="products-list__filters__section">
                            <filter-group [filter]="filter"
                                          [filterItemHeight]="filterItemMaxHeight"
                                          (changedFilter)="onFilterChanged($event)"
                                          (toggledFilter)="toggleDropdown($event)"
                                          (updatedFilter)="updateFilters($event)"></filter-group>
                        </li>
                    </ng-container>
                </ul>
            </div>

        </div>
    </div>
</ng-template>

